export enum CCHoldScopeEnum {
    PER_AUCTION = 'Per Auction',
    PER_VEHICLE = 'Per Vehicle',
    DISABLED = 'Disabled',
}
